var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCreditCard = function SvgIconCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14.375a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM9.125 15.375a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2h-1.5a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.25 6c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 21 19.75H3A1.75 1.75 0 0 1 1.25 18zm2 2.084V6.25h17.5v1.834zm17.5 2v7.666H3.25v-7.665z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCreditCard;